// import ModalForm from "./Form";
import VaNumberTableForm from "./VaNumberTableForm";
import { VANUMBER } from "../../../../../../../Config/ApiUrl";
import { DATATABLE_EXPORT } from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const Schema = {
    components: { VaNumberTableForm },

    data() {
        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: this.ENDPOINT,
            Endpoint:
                VANUMBER,
            tableId: "va-number-table",
            formId: "va-number-table-form",
            rowData: {},
            tableColumns: [
                {
					title: "Bank Name",
					type: "custom-html",
					key: "bank",
					modifier: (value) => {
						return value?.bank_name ?? "-";
					}
                },
                
				{
					title: "Account Number",
					type: "text",
					key: "account_number",
				},
            ],
            actionObj: {
                title: this.$t("action"),
                type: "action",
            },
            options: {
                name: "VaNumberTable",
                url:
                    VANUMBER +
                    "?clc_id_number=" +
                    this.value?.clc_id_number,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    {
                        title: this.$t("edit"),
                        icon: "edit",
                        type: "none",
                        // component: "app-add-modal",
                        component: "va-number-table-form",
                        modalId: "va-number-table-form",
                    },
                    {
                    	title: this.$t("delete"),
                    	icon: "trash",
                    	type: "none",
                    	component: "app-confirmation-modal",
                    	modalId: "demo-delete",
                    },
                ],
                // filters: [
                // ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 3,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    methods: {},
};
